// aanvragenModal.constants.js — constanten, mappings en helper functies

import { Clock, Euro, CheckCircle, FileText, Truck, XCircle } from 'lucide-react';

// v4.1.0: Prijs formattering met komma en 2 decimalen
export const formatPrijs = (prijs) => {
  if (!prijs && prijs !== 0) return '-';
  const num = parseFloat(String(prijs).replace(',', '.'));
  if (isNaN(num)) return '-';
  return num.toFixed(2).replace('.', ',');
};

export const KLANT_STATUS_MAPPING = {
  'Aanvraag ingediend': ['Prijzen nog aan te vragen', 'Prijzen uitgezet', 'Prijzen vervoerders binnen'],
  'Prijs ontvangen': ['Prijs geoffreerd'],
  'Akkoord gegeven': ['Opdracht ontvangen'],
  'Opdracht bevestigd': ['Opdracht verzonden', 'Opdracht bevestigd'],
  'Opdracht': ['Opdracht ontvangen', 'Opdracht verzonden', 'Opdracht bevestigd'],
  'Onderweg': ['Onderweg'],
  'Afgerond': ['Afgeleverd', 'Afgerond'],
  'Geannuleerd': ['Afgeschreven']
};

export const KLANT_STATUS_COLORS = {
  'Aanvraag ingediend': { bg: 'bg-blue-100', text: 'text-blue-800', icon: Clock },
  'Prijs ontvangen':    { bg: 'bg-blue-100', text: 'text-blue-900', icon: Euro },
  'Akkoord gegeven':    { bg: 'bg-orange-100', text: 'text-orange-800', icon: Clock },
  'Opdracht bevestigd': { bg: 'bg-green-100', text: 'text-green-800', icon: CheckCircle },
  'Opdracht':           { bg: 'bg-orange-100', text: 'text-orange-800', icon: FileText },
  'Onderweg':           { bg: 'bg-yellow-100', text: 'text-yellow-800', icon: Truck },
  'Afgerond':           { bg: 'bg-green-100', text: 'text-green-800', icon: CheckCircle },
  'Geannuleerd':        { bg: 'bg-red-100', text: 'text-red-800', icon: XCircle }
};

export const mapToKlantStatus = (interneStatus) => {
  if (!interneStatus) return 'Aanvraag ingediend';
  const status = interneStatus.toLowerCase();
  if (status.includes('opdracht ontvangen')) return 'Akkoord gegeven';
  if (status.includes('opdracht verzonden') || status.includes('opdracht bevestigd')) return 'Opdracht bevestigd';
  if (status.includes('afgeschreven')) return 'Geannuleerd';
  for (const [klantStatus, interneStatussen] of Object.entries(KLANT_STATUS_MAPPING)) {
    if (klantStatus === 'Opdracht') continue;
    if (interneStatussen.some(s => status.includes(s.toLowerCase()))) return klantStatus;
  }
  return 'Aanvraag ingediend';
};

export const formatGoederen = (aanvraag) => {
  const goederen = [];
  for (let i = 1; i <= 5; i++) {
    const aantal      = aanvraag[`Goed${i}_Aantal`];
    const soort       = aanvraag[`Goed${i}_Soort`];
    const omschrijving = aanvraag[`Goed${i}_Omschrijving`];
    const lengte      = aanvraag[`Goed${i}_Lengte`];
    const breedte     = aanvraag[`Goed${i}_Breedte`];
    const hoogte      = aanvraag[`Goed${i}_Hoogte`];
    const gewicht     = aanvraag[`Goed${i}_Gewicht`];
    if (!soort && !omschrijving) continue;
    const parts = [];
    if (aantal) parts.push(`${aantal}x`);
    if (soort) parts.push(soort);
    if (omschrijving) parts.push(omschrijving);
    if (lengte && breedte && hoogte) parts.push(`${lengte}x${breedte}x${hoogte}m`);
    if (gewicht) parts.push(`${gewicht}kg`);
    if (parts.length > 0) goederen.push(parts.join(' '));
  }
  return goederen.length > 0 ? goederen.join(', ') : '-';
};

export const formatDate = (date) => {
  if (!date) return '-';
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return String(date).substring(0, 10);
    return d.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch { return String(date).substring(0, 10); }
};
